import TensaiService from '../../services/tensai';

// actions
export const FETCH_TENANTS = 'FETCH_TENANTS';

// action: recupera a lista de clientes
export function fetchTenants(dispatch) {
  const service = new TensaiService();
  const dataPromise = service.fetchTenants();
  dispatch({ type: FETCH_TENANTS, payload: dataPromise });
}
